//============================================================================
// Name        : tenant_handheld_settings.ts
// Purpose     : Implement Handheld settings
// Created     : 2021-01-01
// Author      : Alireza mohagheghi
// Copyright   : Copyright 2021 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../index";
import swal from "sweetalert";

class TenantHandheldSettings {
    text1_content: any;
    text2_content: any;
    constructor() {
        const _this = this;
        _this.text1_content = $('#ui_settings_hh_text_1').val();
        _this.text2_content = $('#ui_settings_hh_text_2').val();
        const element1 = $("#unique_epcs");
        const element2 = $('#create_catalog_items');
        if (element1.is(":checked")) {
            $('#stack_epcs').removeAttr('disabled');
           // $(".hide_item").show();
        } else {
            $('#stack_epcs').removeAttr('checked');
            $('#stack_epcs').attr('disabled','true');
            //$(".hide_item").hide();
        }
        element1.on("click", function() {
            if ($(this).is(":checked")) {
                $('#stack_epcs').removeAttr('disabled');
                //$(".hide_item").show();
            } else {
                $('#stack_epcs').removeAttr('checked');
                $('#stack_epcs').attr('disabled','true');
                //$(".hide_item").hide();
            }
        });

        if (element2.is(":checked")) {
            $('#auto_create_catalog_items').removeAttr('disabled');
           // $(".hide_item").show();
        } else {
            $('#auto_create_catalog_items').removeAttr('checked');
            $('#auto_create_catalog_items').attr('disabled','true');
            //$(".hide_item").hide();
        }
        element2.on("click", function() {
            if ($(this).is(":checked")) {
                $('#auto_create_catalog_items').removeAttr('disabled');
                //$(".hide_item").show();
            } else {
                $('#auto_create_catalog_items').removeAttr('checked');
                $('#auto_create_catalog_items').attr('disabled','true');
                //$(".hide_item").hide();
            }
        });

        $('.sn-item-details').on('click', function(){
            var value = $(this).text();
            _this.text1_content = $('#ui_settings_hh_text_1').val() + '{{' + value +'}}';
            _this.text2_content = $('#ui_settings_hh_text_2').val() + '{{' + value +'}}';
        });

        $('#ui_settings_hh_text_1').on('click',function(){
            $(this).val(_this.text1_content);
        });

        $('#ui_settings_hh_text_2').on('click',function(){
            $(this).val(_this.text2_content);
        });

        $('#ui_settings_hh_text_1').on("input",function(){
            _this.text1_content = $(this).val();
        });

        $('#ui_settings_hh_text_2').on('input',function(){
            _this.text2_content = $(this).val();
        });
        
        $('.sn-tag-details').on('click', function(){
        var value = $(this).text();
        $('#ui_settings_hh_text_3').val( $('#ui_settings_hh_text_3').val() + '{{' + value +'}}');
        });
    }
}

export function LoadPage() {
    InitPage("tenant_handheld_settings edit", () => {
        const c = new TenantHandheldSettings();
    });
}
